//
// Module for employer payment detail
//
rs.module("content/employer/reporting/payments/detail",

    [
        "controls/data/grid",
        "controls/components/event-banner",
    ],

    function (gridModule, eventBanner) {

        // Initialize the module
        function initialize(paymentDetailsGridLrsApi, jsSelectors, ajaxUrls) {

            var employerPaymentEdit = $.js(jsSelectors.employerPaymentEdit);

            var savePaymentButton = employerPaymentEdit.js(jsSelectors.savePaymentButton, { required: false });
            var postPaymentButton = employerPaymentEdit.js(jsSelectors.postPaymentButton, { required: false });

            var paymentDetailsForm = employerPaymentEdit.js(jsSelectors.paymentDetailsForm);

            var employerPaymentKeyInput = paymentDetailsForm.js(jsSelectors.employerPaymentKeyInput);
            var loadDetailForBatchSelect = paymentDetailsForm.js(jsSelectors.loadDetailForBatchSelect, { required: false });
            var addDetailLink = paymentDetailsForm.js(jsSelectors.addDetailLink);
            var loadingSpinner = paymentDetailsForm.js(jsSelectors.loadingSpinner, { required: false });

            // add grid row for inline editing
            addDetailLink.on("click", function () {
                paymentDetailsGridLrsApi.addRow();
            });

            if (loadDetailForBatchSelect) {
                // pre-poplulate grid rows for inline editing
                loadDetailForBatchSelect.on("change", function () {

                    // clear grid
                    paymentDetailsGridLrsApi.rejectChanges();

                    // Remove existing event banner messages
                    eventBanner.removeAllMessages();

                    // if the user selects "empty" in the select picker, don't try to load it
                    // just let the grid be blank until they select a valid value
                    if (loadDetailForBatchSelect.val() != '') {
                        loadingSpinner.show();

                        gridModule.update(
                            ajaxUrls.loadDetailForBatch,
                            { employerPaymentKey: employerPaymentKeyInput.val(), transmittalBatchKey: loadDetailForBatchSelect.val() },
                            paymentDetailsGridLrsApi.agGridApi,
                            function done() { },
                            { appendAsPending: true }
                        ).always(function () {
                            loadingSpinner.hide()
                        });
                    }
                });
            }

            // Based if there exists inline edited rows, 
            // toggle payment buttons
            paymentDetailsGridLrsApi.rowChanged(function (change) {
                var rowsDisplayed = paymentDetailsGridLrsApi.getChanges().length > 0;

                if (savePaymentButton) {
                    savePaymentButton.setDisabled(rowsDisplayed);
                }

                if (postPaymentButton) {
                    postPaymentButton.setDisabled(rowsDisplayed);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);